import { theme } from '@features/executive-report/domain/theme';
import { Slide, TextProps } from '@features/powerpoint';

const SHAPE_X = 7;
const SHAPE_WIDTH = 2.74;
const TEXT_X = SHAPE_X + 0.03;

const applyStatYOffset = (index: number) => index * 0.71;

export type ProfileStatsOptions = {
  data: {
    category: string;
    name: string;
    value: number | string;
  }[];
};

export const profileStats = (options: ProfileStatsOptions): Slide => ({
  texts: [
    {
      text: 'Profile Stats'.toUpperCase(),
      options: {
        fontSize: 11,
        h: 0.29,
        w: SHAPE_WIDTH,
        x: TEXT_X,
        y: 2.3,
      },
    },
    ...options.data.flatMap((row, index): TextProps[] => [
      {
        text: row.category.toUpperCase(),
        options: {
          fontSize: 8,
          color: theme.colors.inmarketGreen,
          bold: true,
          h: 0.25,
          w: SHAPE_WIDTH,
          x: TEXT_X,
          y: 2.91 + applyStatYOffset(index),
        },
      },
      {
        text: [
          {
            text: row.name,
            options: {
              bold: true,
            },
          },
          {
            text: ` (${row.value})`,
          },
        ],
        options: {
          fontSize: 16,
          h: 0.37,
          w: SHAPE_WIDTH,
          x: TEXT_X,
          y: 3.12 + applyStatYOffset(index),
        },
      },
    ]),
  ],
  shapes: [
    {
      shapeName: 'rect',
      options: {
        fill: {
          color: theme.colors.black,
          transparency: 13,
        },
        line: {
          width: 1,
          color: theme.colors.inmarketGreen,
        },
        h: 2.8,
        w: SHAPE_WIDTH,
        x: SHAPE_X,
        y: 2.23,
      },
    },
    {
      shapeName: 'line',
      options: {
        line: { width: 1, color: theme.colors.inmarketGreen },
        h: 0,
        w: SHAPE_WIDTH,
        x: SHAPE_X,
        y: 2.76,
      },
    },
  ],
});
